import { DashboardType } from '../../../pages/Dashboard/Dashboard.types';
import { LoaderAlert } from '../LoaderAlert.component';
import { useStyles } from './LayoutBackground.styles';

interface LayoutBackgroundProps {
  isLoaderHidden?: boolean;
  isCentralLineHidden?: boolean;
  dashboardType?: DashboardType;
}

export const LayoutBackground: React.FC<LayoutBackgroundProps> = ({
  isLoaderHidden,
  isCentralLineHidden,
  dashboardType = 'assessment',
  ...props
}) => {
  const classes = useStyles();

  const getBackgroundColor = () => {
    switch (dashboardType) {
      case 'assessment':
        return 'linear-gradient(#3C419A, #27284C)';
      case 'training':
        return 'linear-gradient(#153E1D, #347F42)';
    }
  };

  return (
    <>
      <div>
        <LoaderAlert hideLoader={isLoaderHidden} />
      </div>
      <div
        className={classes.container}
        style={{
          backgroundImage: getBackgroundColor(),
        }}
      >
        {!isCentralLineHidden && (
          <svg
            viewBox="0 0 1000 1000"
            width="100%"
            height="100%"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform="translate(0,250)"
          >
            <path
              d="M-1107.23 216.826C-953.577 284.861 -768.044 275.087 -622.084 192.551C-535.33 143.006 -462.074 69.4825 -367.99 30.8166C-265.51 -11.1015 -153.247 -5.84953 -45.8056 25.4289C10.9782 41.9677 66.4338 65.7075 118.118 93.0216C167.842 119.273 216.415 149.232 264.472 178.989C326.521 217.775 388.47 256.818 454.198 286.945C490.49 303.496 527.888 317.214 566.337 327.481C630.209 344.117 694.87 350.371 759.168 349.952C861.931 349.119 966.252 331.375 1072.42 313.463C1177.26 295.921 1282.35 278.479 1386.33 269.213C1479.48 261.061 1572.38 259.64 1665.38 271.622C1677.82 273.216 1690.17 275.067 1702.66 277.277C1759.08 287.142 1814.44 304.309 1859.18 337.226C1913.9 377.304 1948.45 445.433 1930.85 504.175"
              stroke="#C3C6FF"
              strokeWidth="0.9463"
              strokeMiterlimit="10"
            />
          </svg>
        )}
        <svg
          viewBox="0 0 1000 1000"
          width="100%"
          height="100%"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="translate(500,0)"
        >
          <path
            d="M838.534 1942.09C849.444 1882.32 864.733 1799.21 896.88 1715.38C929.012 1631 974.16 1547.12 1021.87 1465.93C1033.8 1445.71 1045.99 1425.2 1058.21 1405.24C1094.56 1345.1 1131.74 1284.93 1159.12 1220.04C1162.24 1212.49 1165.37 1204.94 1168.22 1197.4C1198.51 1116.66 1210.91 1028.92 1198.8 945.404C1182.63 832.942 1126.19 736.181 1054.01 651.444C970.711 553.714 858.142 468.911 754.316 401.313C707.603 370.7 663.797 345.545 621.02 328.11C558.946 302.596 485.998 284.555 455.251 207.881C438.977 166.801 442.445 118.849 453.195 74.3064C457.453 57.0438 462.563 40.5891 468.537 25.4956C490.096 -29.0087 518.007 -73.1633 533.605 -122.811C547.154 -166.042 550.232 -218.411 526.132 -262.609C522.359 -269.428 518.042 -275.957 513.178 -282.195C468.567 -338.592 383.533 -353.279 310.147 -356.092C256.979 -358.043 202.5 -357.193 152.337 -371.395C132.827 -376.979 113.814 -384.789 96.097 -395.953C28.3213 -438.75 -6.297 -526.113 2.44913 -605.464C11.1881 -685.091 60.9244 -751.94 119.921 -802.982C194.065 -867.417 295.908 -909.049 399.379 -908.947"
            stroke="white"
            strokeOpacity="0.3"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
        <svg
          viewBox="0 0 1000 1000"
          width="100%"
          height="100%"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="translate(500,0)"
        >
          <path
            d="M0.979526 -654.773C-2.16353 -486.758 78.7762 -319.525 211.444 -216.98C290.749 -156.22 386.923 -117.198 459.04 -45.4628C537.411 32.751 576.093 138.27 588.915 249.434C595.685 308.189 595.302 368.511 590.161 426.742C585.241 482.755 576.457 539.143 567.658 594.979C555.962 667.212 543.99 739.452 541.701 811.72C540.515 851.59 542.369 891.381 547.811 930.804C557.239 996.13 576.543 1058.16 601.857 1117.27C642.466 1211.67 699.266 1300.95 756.938 1391.87C813.753 1481.71 870.574 1571.82 919.428 1664.07C963.056 1746.78 1000.38 1831.86 1025.39 1922.23C1028.75 1934.32 1031.83 1946.41 1034.64 1958.79C1047.42 2014.63 1053.05 2072.3 1040.06 2126.31C1024.33 2192.28 974.922 2250.55 913.95 2257.1"
            stroke="#C3C6FF"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
        {props.children}
      </div>
    </>
  );
};
